import * as React from "react"
import { Box, Skeleton } from "@mui/material"
import { AmchartSeeker, ModalSeeker } from "@ui-seeker/core"

import { useCatalogueDetailsPriceEvolutionData } from "./@hooks"
import CatalogueDetailsPriceEvolutionChartToolbar from "./Toolbar"


export default function CatalogueDetailsPriceStockEvolutionChart() {

    const { 
        dataEvolution, dataEvolutionKeys, productTitle, isLoadingDataEvolution, currency, resetEvolutionData, 
        handleChangeEvolutionPeriod, evolutionDatePeriod, retailer, chartColors
    } = useCatalogueDetailsPriceEvolutionData()
    
    if (isLoadingDataEvolution) return <Skeleton variant="rectangular" height={1000} />
	if (!dataEvolution?.length || isLoadingDataEvolution) return <></>

    const statusLabels = {
		'stock': 'Stock',
		'out-of-stock': 'Out Of Stock',
		'deslisted': 'Delisted',
		'not-listed': 'Not Listed'
	}
    
    return <ModalSeeker 
        hideActions 
        isOpen={!!dataEvolution?.length} 
        title={`Price & Stock Evolution - ${productTitle} - ${retailer} `} 
        controller={() => resetEvolutionData()}
        containerProps={{
            maxWidth:"xl"
        }}
    >
        <AmchartSeeker
            rootID="price-stock-evolution"
            data={dataEvolution}
            title={<Box id="evolution-price-chart"></Box>}
            pdfProps={{
                titlePDF:`Price & Stock Evolution - ${productTitle} - ${retailer} `
            }}
            series={[
                {
                    name: "Price",
                    yField: "price",
                    xField: "date",
                    type: "line",
                    connect: true,
                    tooltip: {
                        labelText: "[bold]Price: {valueY}[/]",
                    },
                },
                ...(dataEvolutionKeys.map(key => ({
                    name: statusLabels[key], 
                    yField: key,
                    xField: "date",
                    color: chartColors[key],
                    strokes: {
                        strokeDasharray: [0, 100000]
                    },
                    bullets: { 
                        hidden: false, 
                        radius: 10,
                        fill: chartColors[key]
                    },
                    tooltip: {
                        labelText: "[bold]{statusLabel}[/]"
                    },
                }))),	
            ]}
            chartProps={{
                numberFormat: `#,###.00 ' ${currency}'`,
                dateFormatReceived: 'yyyyMMdd',
                xAxis: {
                    categoryField: 'date',
                    isDateAxis: true,
                    dateFormat: 'dd MMM yyyy',
                    baseInterval: {
                        timeUnit: 'day',
                        count: 1
                    }
                }
            }}
            cardProps={{
                actions: <CatalogueDetailsPriceEvolutionChartToolbar dateRange={evolutionDatePeriod} onChange={handleChangeEvolutionPeriod} handleClick={resetEvolutionData} /> 
            }}
            sx={{ height: 500 }}
        />
    </ModalSeeker>
}